export default __webpack_public_path__ + "static/media/noMessage.6b94df4d.svg";